/**
 * Upload File Plugin
 */
(function ($) {

    "use strict";

    $.fn.uploadFile = function (options) {

        const $addFileButton = $(this);

        const $fileInput = $('#' + options.fileInputId);

        const construct = {
            init : function () {
                const _this = this;

                /**
                 * Prompt choose file dialog
                 */
                $addFileButton.on('click', function ($e) {
                    $fileInput.trigger('click');
                });

                /**
                 * Handle file upload
                 */
                $fileInput.on('change', function () {
                    let fileInput = document.getElementById(options.fileInputId);
                    if (fileInput.files.length === 0) {
                        // no file was chosen
                        return;
                    }

                    _this.uploadFile(fileInput.files[0]);
                });

                return _this;
            },

            uploadFile: function (file) {
                const _this = this;

                let fileUploadProgressModalElement = document.getElementById('file-upload-modal');
                let fileUploadProgressModal = new Modal(fileUploadProgressModalElement);

                fileUploadProgressModal.show();

                let formData = _this.buildFormData(file);
                axios.post(options.uploadUrl, formData, {
                    onUploadProgress: progressEvent => {
                        // display progress here as 0
                        const percentCompleted = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        // then again here if not 100%
                        fileUploadProgressModal._element.querySelector('.modal-body').innerHTML =
                            '<div class="progress">' +
                                '<div class="progress-bar progress-bar-striped bg-success" role="progressbar" ' +
                                'style="width:'+ percentCompleted + '%" aria-valuenow="' + percentCompleted +
                                '" aria-valuemin="0" aria-valuemax="100">' + percentCompleted + '%</div></div>';
                    }
                }).then(res => {
                    // display progress  100% here
                    setTimeout(function(){
                        window.location.reload();
                    }, 1000);
                }).catch(error => {
                    let errorMessage = error.response?.data?.message;
                    if (errorMessage === '' || errorMessage === undefined) {
                        errorMessage = options.errorMessage;
                    }

                    setTimeout(function(){
                        fileUploadProgressModal._element.querySelector('.modal-body').innerHTML =
                            '<span class="text-danger">' + errorMessage + '</div>';
                    }, 1000);

                });
            },

            buildFormData: function (file) {
                let formData = new FormData();
                formData.set('file_to_upload', file);
                formData.set('object_type', options.objectType),
                    formData.set('object_id', options.objectId);

                return formData;
            }
        };

        const uploadFile = $.extend(construct, {}, options);
        uploadFile.init();

        return $addFileButton;
    };

}(jQuery));
